import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi everyone! I’m <span className="purple">Mufutau Umar Olamilekan</span> from
            <span className="purple"> Lagos, Nigeria</span>, also known as <span className="purple">VoidSynth</span>.
            <br />
            I’m a UI/UX Designer and Fullstack Web Developer, passionate about crafting clean, functional,
            and human-centered digital experiences.
            <br />
            <br />
            I completed the ALX Software Engineering Program powered by ALX Africa and Holberton School,
            where I gained hands-on experience in frontend, backend, and system design.
            <br />
            <br />
            Outside of coding, I love:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Call of Duty Mobile 🎮
            </li>
            <li className="about-activity">
              <ImPointRight /> Designing and exploring creative tech ideas 🎨
            </li>
            <li className="about-activity">
              <ImPointRight /> Learning about AI, automation, and Forex trading 📈
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            “I strive to build digital experiences that feel as intelligent as they are beautiful.”
          </p>
          <footer className="blockquote-footer">VoidSynth</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
